import { defineStore } from 'pinia'
import { ref } from 'vue'
import Message from '@/modules/core/models/modalMessage/Message'
import { MessageEnum } from '../models/enums'

export const useMessageStore = defineStore('messageStore', () => {
  const messageView = ref<Message | null>(null)

  function successModal(data: Partial<Message>) {
    const message = new Message({
      title: data.title,
      label: data.label,
      buttons: data.buttons,
      extra: data.extra,
      type: MessageEnum.SUCCESS
    })
    messageView.value = message
  }

  function errorModal(data: Partial<Message>) {
    const message = new Message({
      title: data.title || 'common.error.title',
      label: data.label,
      buttons: data.buttons,
      extra: data.extra,
      type: MessageEnum.ERROR
    })
    messageView.value = message
  }

  function pendingModal(data: Partial<Message>) {
    const message = new Message({
      title: data.title,
      label: data.label,
      buttons: data.buttons,
      extra: data.extra,
      type: MessageEnum.PENDING
    })
    messageView.value = message
  }

  function supportModal(data: Partial<Message>) {
    const message = new Message({
      title: data.title,
      label: data.label,
      buttons: data.buttons,
      extra: data.extra,
      type: MessageEnum.SUPPORT
    })
    messageView.value = message
  }

  function getModalMessage(): Message | null {
    return messageView.value as Message
  }

  function clearMessage() {
    messageView.value = null
  }

  return {
    successModal,
    errorModal,
    pendingModal,
    supportModal,
    getModalMessage,
    clearMessage
  }
})
